import { ComponentProps, FC } from 'react'
import { styled } from '../../config'

const Container = styled('div', {
  width: '300px',
  height: '10px',
  borderRadius: '9999px',
  background: '$whiteA050',
  overflow: 'hidden',
  variants: {
    size: {
      sm: {
        height: '6px'
      }
    }
  }
})

const Fill = styled('div', {
  height: '100%',
  background: '$white',
  transition: '100ms linear',
  variants: {
    variant: {
      gradient: {
        background:
          'linear-gradient(90deg, rgba(179, 255, 171, 0.40) 0%, rgba(18, 255, 247, 0.40) 100%)'
      }
    }
  }
})

export const Progress: FC<
  { progress: number } & ComponentProps<typeof Fill> & ComponentProps<typeof Container>
> = ({ progress, variant, ...rest }) => {
  return (
    <Container {...rest}>
      <Fill css={{ width: `${progress}%` }} variant={variant} />
    </Container>
  )
}
